import { Input } from '@chakra-ui/core';
import styled from '@emotion/styled';

export const CustonInput = styled(Input)`
  ::placeholder {
    color: #b8b7b8;
  }
`;
